import { AuthResponse } from 'data/auth/api'
import { callApi } from 'services/api'

const API_RECOVERY_EMAIL_PATH = '/admin/auth/reset-password'
const API_CHANGE_PASSWORD_PATH = '/admin/auth/change-password'
export const API_LOGIN_PATH = '/admin/auth/login'

export async function apiEmailLogin(email: string, password: string): Promise<AuthResponse> {
  return callApi<AuthResponse>({
    method: 'post',
    url: API_LOGIN_PATH,
    data: {
      email,
      password,
    },
  })
}

export async function apiSendRecoveryEmail(email: string): Promise<void> {
  return callApi<void>({
    method: 'post',
    url: API_RECOVERY_EMAIL_PATH,
    data: {
      email,
    },
  })
}

export async function apiChangePassword(email: string, password: string, token: string): Promise<void> {
  return callApi<void>({
    method: 'post',
    url: API_CHANGE_PASSWORD_PATH,
    data: {
      email,
      password,
      token,
    },
  })
}
